import { SvgIcon } from '@mui/material';

const ThickCloseIcon = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M18 6L6 18M6 6l12 12"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </SvgIcon>
);

export default ThickCloseIcon;
